import { Component, OnInit, OnDestroy } from "@angular/core";
import { GooglePolylinePoint } from "src/app/models/google-polyline-point";
import { GooglePolyline } from "src/app/models/google-polyline";
import { ColorCapaEnum } from "../../../../shared/enums/color-capa.enum";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
} from "@angular/forms";
import { CatalogoService } from "src/app/services/catalogo.service";
import { Observable, from, BehaviorSubject } from "rxjs";
import { AppMovilService } from "src/app/services/app-movil.service";
import { MapUtils } from "../../../../shared/utils/map-utils";
import { Usuario } from "src/app/models/entities/usuario";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { UsuarioSesionDTO } from "src/app/models/dtos/usuario-sesion-dto";
import {
  take,
  filter,
  switchMap,
  map,
  find,
  concatMap,
  toArray,
  tap,
} from "rxjs/operators";
import { Estado } from "src/app/models/entities/estado";
import { DateUtils } from "src/app/shared/utils/date-utils";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { Segmento } from "src/app/models/entities/segmento";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { Capa } from "src/app/models/entities/capa";
import { CapaService } from "src/app/services/capa.service";
import { LoaderService } from "src/app/services/loader.service";
import { AlertasService } from "src/app/services/alertas.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { LevantamientoSeleccionadoDTO } from "src/app/models/dtos/levantamiento-seleccionado-dto";
import { Coordenada } from "src/app/models/entities/coordenada";
import { SegmentoService } from "src/app/services/segmento.service";
import { CapaSegmentosDTO } from "src/app/models/dtos/capa-segmentos-dto";
import { FormUtils } from "src/app/shared/utils/form-utils";
import { LevantamientoAvanceService } from "src/app/services/levantamiento-avance.service";
import { LevantamientoActualComponent } from "../levantamiento-actual/levantamiento-actual.component";
import { ArchivoCoordenadaService } from "src/app/services/archivo-coordenada.service";
import { ArchivoCoordenada } from "src/app/models/entities/archivo-coordenada";
import { MapsAPILoader } from "@agm/core";
import { AvanceDTO } from "src/app/models/dtos/avance-dto";
declare var JSZip: any;
declare var toGeoJSON: any;

@Component({
  selector: "levantamiento-avance",
  templateUrl: "./levantamiento-avance.component.html",
  styleUrls: ["./levantamiento-avance.component.scss"],
})
export class LevantamientoAvanceComponent implements OnInit, OnDestroy {
  public usuarioEnSesion: Usuario;
  public filtroForm: FormGroup;
  public catEstados: Estado[];
  public catDireccionesAdjuntas: ElementoCatalogo[];
  public catTipoObra: ElementoCatalogo[];
  public catTipoLevantamiento: ElementoCatalogo[];
  public catCapas: ElementoCatalogo[];
  public catSubElementos: ElementoCatalogo[];
  public catColores: ElementoCatalogo[];

  public levantamientosObras: LevantamientoObra[];
  public datosObraSeleccionada$: Observable<LevantamientoSeleccionadoDTO>;
  public readonly TAB_ESTATUS = 0;
  public readonly TAB_CREACION_CAPA = 1;
  public readonly TAB_CARGAR_ARCHIVOS = 2;
  public readonly TAB_AVANCES = 3;
  public readonly TAB_ADMINISTRACION = 4;
  public readonly TAB_CARGAFICHA = 5;

  public tabActiva: number = this.TAB_ESTATUS;
  public readonly CAPA_PROYECTO_PROCESO: string = "0";
  public readonly CAPA_PROYECTO_PLANEACION: string = "4";
  public readonly CAPA_META_ACTUAL: string = "1";
  public readonly CAPA_COMPLETADO: string = "2";
  public readonly CAPA_ESTRUCTURA: string = "5";

  public constructor(
    public dateUtils: DateUtils,
    private formBuilder: FormBuilder,
    private catalogoService: CatalogoService,
    private facadeSesionService: FacadeSesionService,
    private levantamientoObraService: LevantamientoObraService,
    private capaService: CapaService,
    private usuarioService: UsuarioService,
    private segmentoService: SegmentoService,
    public formUtils: FormUtils,
    public levantamientoAvanceService: LevantamientoAvanceService,
    private archivoCoordenadaService: ArchivoCoordenadaService,
    private mapUtils: MapUtils,
    private mapsAPILoader: MapsAPILoader
  ) {}

  public ngOnInit(): void {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad(
      "Levantamiento de obra"
    );
    this.datosObraSeleccionada$ = this.levantamientoAvanceService.datosObraSeleccionada$.asObservable();
    this.cargarCatalogos();
    this.inicializarForm();
    this.inicializarFiltrosSelects();
  }

  public inicializarForm(): void {
    this.filtroForm = this.formBuilder.group({
      keyCatEstado: new FormControl("-1", [
        Validators.required,
        this.validarId,
      ]),
      keyLevantamientoObra: new FormControl("-1", [
        Validators.required,
        this.validarId,
      ]),
    });
  }

  public onTabChange(event: any): void {
    this.tabActiva = event.index;
  }

  public async inicializarFiltrosSelects() {
    await this.mapsAPILoader.load();
    this.filtroForm
      .get("keyCatEstado")
      .valueChanges.pipe(
        tap(() => {
          this.levantamientoAvanceService.datosObraSeleccionada$.next(null);
          this.filtroForm.get("keyLevantamientoObra").setValue("-1");
        }),
        filter((keyCatEstado: string) => keyCatEstado !== "-1"),
        switchMap((keyCatEstado: string) =>
          this.levantamientoObraService.findAprobados().pipe(
            take(1),
            map((levsObras: LevantamientoObra[]) =>
              levsObras.filter(
                (levObra: LevantamientoObra) =>
                  levObra.keyCatEstado === keyCatEstado
              )
            )
          )
        )
      )
      .subscribe((levantamientosObras: LevantamientoObra[]) => {
        this.levantamientosObras = levantamientosObras;
      });

    this.filtroForm
      .get("keyLevantamientoObra")
      .valueChanges.pipe(
        tap((keyLevantamientoObra: string) => {
          if (keyLevantamientoObra === "-1") {
            this.levantamientoAvanceService.datosObraSeleccionada$.next(null);
          }
        }),
        filter((keyLevantamientoObra: string) => keyLevantamientoObra !== "-1"),
        map((keyLevObra: string) =>
          this.levantamientosObras.find(
            (levObra: LevantamientoObra) => levObra.key === keyLevObra
          )
        ),
        concatMap((levObra: LevantamientoObra) =>
          this.usuarioService.findByKey(levObra.keyUsuarioLevantamiento).pipe(
            take(1),
            concatMap((usuarioLevantamiento: Usuario) =>
              this.usuarioService.findByKey(levObra.keyUsuarioAprobacion).pipe(
                take(1),
                map((usuarioAprobo: Usuario) => {
                  let datosObra: LevantamientoSeleccionadoDTO = {};
                  datosObra.direccionAdjunta = this.catDireccionesAdjuntas.find(
                    (direccionAdjunta: ElementoCatalogo) =>
                      direccionAdjunta.key === levObra.keyCatDireccionAdjunta
                  );
                  datosObra.tipoObra = this.catTipoObra.find(
                    (tipoObra: ElementoCatalogo) =>
                      tipoObra.key === levObra.keyCatTipoObra
                  );
                  datosObra.estado = this.catEstados.find(
                    (estado: Estado) => estado.key === levObra.keyCatEstado
                  );
                  datosObra.tipoLevantamiento = this.catTipoLevantamiento.find(
                    (tipoLevantamiento: ElementoCatalogo) =>
                      tipoLevantamiento.key === levObra.keyCatTipoLevantamiento
                  );
                  datosObra.usuarioAprobo = usuarioAprobo;
                  datosObra.usuarioLevantamiento = usuarioLevantamiento;
                  datosObra.levObra = levObra;
                  return datosObra;
                }),
                concatMap((levSelDTO: LevantamientoSeleccionadoDTO) =>
                  this.capaService
                    .findByKeyLevantamientoObra(levSelDTO.levObra.key)
                    .pipe(
                      take(1),
                      concatMap((capas: Capa[]) =>
                        from(capas).pipe(
                          concatMap((capa: Capa) =>
                            this.segmentoService.findByKeyCapa(capa.key).pipe(
                              take(1),
                              map((segmentos: Segmento[]) => {
                                let longitudSegmentos: number = 0;
                                segmentos.forEach((segmento: Segmento) => {
                                  let path: Array<google.maps.LatLng> = Array.from(
                                    segmento.coordenadas,
                                    (c: Coordenada) =>
                                      new google.maps.LatLng(
                                        c.latitud,
                                        c.longitud
                                      )
                                  );
                                  let longitudSegmento: number = google.maps.geometry.spherical.computeLength(
                                    path
                                  );
                                  longitudSegmentos += parseFloat(
                                    longitudSegmento.toFixed(2)
                                  );
                                });
                                let capaSegmentos: CapaSegmentosDTO = {
                                  capa,
                                  segmentos: segmentos.map(
                                    (segmento: Segmento) => ({
                                      ...segmento,
                                      nombreColor: this.catColores.find(
                                        (e: ElementoCatalogo) =>
                                          e.key === segmento.keyCatColor
                                      ).nombre,
                                    })
                                  ),
                                  nombreCapa: this.catCapas.find(
                                    (e: ElementoCatalogo) =>
                                      e.key === capa.keyCatCapa
                                  ).nombre,
                                  longitudSegmentos,
                                };
                                return capaSegmentos;
                              })
                            )
                          ),
                          toArray()
                        )
                      ),
                      map(
                        (capasSegmentos: CapaSegmentosDTO[]) =>
                          ({
                            ...levSelDTO,
                            capasSegmentos,
                          } as LevantamientoSeleccionadoDTO)
                      )
                    )
                )
              )
            )
          )
        ),
        concatMap((datosObraSeleccionada: LevantamientoSeleccionadoDTO) =>
          this.archivoCoordenadaService
            .findByKeyLevantamientoObra(datosObraSeleccionada.levObra.key)
            .pipe(
              take(1),
              map((archivos: ArchivoCoordenada[]) => {
                datosObraSeleccionada.capasSegmentos.forEach(
                  (capaSegmentos: CapaSegmentosDTO) => {
                    capaSegmentos.segmentos.forEach((segmento: Segmento) => {
                      segmento.coordenadas.forEach(
                        (coordenada: Coordenada, indice: number) => {
                          let archivosEncontrados: ArchivoCoordenada[] = archivos.filter(
                            (a: ArchivoCoordenada) =>
                              a.keySegmento === segmento.key &&
                              a.keyCoordenada === indice.toString()
                          );
                          if (archivosEncontrados.length > 0) {
                            coordenada.archivos = archivosEncontrados;
                          } else {
                            coordenada.archivos = [];
                          }
                        }
                      );
                    });
                    capaSegmentos.mostrarCapa = true;
                    switch (capaSegmentos.capa.keyCatCapa) {
                      case this.CAPA_PROYECTO_PROCESO:
                        capaSegmentos.zIndex = 10;
                        break;
                      case this.CAPA_PROYECTO_PLANEACION:
                        capaSegmentos.zIndex = 10;
                        break;
                      case this.CAPA_META_ACTUAL:
                        capaSegmentos.zIndex = 20;
                        break;
                      case this.CAPA_COMPLETADO:
                        capaSegmentos.zIndex = 30;
                        break;
                      case this.CAPA_ESTRUCTURA:
                        capaSegmentos.zIndex = 40;
                        break;
                    }
                  }
                );
                // Se crea el arreglo de avances. Cada avance tiene su propia fecha y un arreglo de segmentos. Se agrupan segmentos por fecha
                //  Ademas, ese arreglo de segmentos tiene un calculo con la suma de todas sus longitudes.
                let capaCompletado: CapaSegmentosDTO = datosObraSeleccionada.capasSegmentos.find(
                  (capaSegmentos: CapaSegmentosDTO) =>
                    capaSegmentos.capa.keyCatCapa === this.CAPA_COMPLETADO
                );
                let avances: AvanceDTO[] = [];
                if (capaCompletado) {
                  let mapaFechas = new Map<number, Segmento[]>();
                  capaCompletado.segmentos.forEach((segmento: Segmento) => {
                    let segmentos: Segmento[] = mapaFechas.get(
                      segmento.fechaRegistro
                        ? segmento.fechaRegistro
                        : segmento.fechaCreacion
                    );
                    if (!segmentos) {
                      segmentos = [];
                    }
                    segmentos.push(segmento);
                    mapaFechas.set(
                      segmento.fechaRegistro
                        ? segmento.fechaRegistro
                        : segmento.fechaCreacion,
                      segmentos
                    );
                  });

                  mapaFechas.forEach((segmentos: Segmento[], fecha: number) => {
                    let longitudSegmentos: number = 0;
                    segmentos.forEach((segmento: Segmento) => {
                      let path: Array<google.maps.LatLng> = Array.from(
                        segmento.coordenadas,
                        (c: Coordenada) =>
                          new google.maps.LatLng(c.latitud, c.longitud)
                      );
                      let longitudSegmento: number = google.maps.geometry.spherical.computeLength(
                        path
                      );
                      longitudSegmentos += parseFloat(
                        longitudSegmento.toFixed(2)
                      );
                    });

                    let avance: AvanceDTO = {
                      capa: capaCompletado.capa,
                      nombreCapa: capaCompletado.nombreCapa,
                      zIndex: capaCompletado.zIndex,
                      mostrarCapa: capaCompletado.mostrarCapa,
                      fecha,
                      segmentos,
                      longitudSegmentos,
                    };

                    avances.push(avance);
                  });
                }
                datosObraSeleccionada.avances = avances;

                return datosObraSeleccionada;
              })
            )
        )
      )
      .subscribe((datosObraSeleccionada: LevantamientoSeleccionadoDTO) => {
        this.tabActiva = this.TAB_ESTATUS;
        this.levantamientoAvanceService.datosObraSeleccionada$.next(
          datosObraSeleccionada
        );
      });
  }

  public async cargarCatalogos(): Promise<void> {
    this.catEstados = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1))
      .toPromise();
    this.catDireccionesAdjuntas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS)
      .pipe(take(1))
      .toPromise();
    this.catTipoObra = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1))
      .toPromise();
    this.catTipoLevantamiento = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_LEVANTAMIENTOS)
      .pipe(take(1))
      .toPromise();
    this.catSubElementos = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SUB_ELEMENTOS)
      .pipe(take(1))
      .toPromise();
    this.catColores = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES)
      .pipe(take(1))
      .toPromise();
    this.catCapas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CAPAS)
      .pipe(take(1))
      .toPromise();
  }

  private validarId(control: AbstractControl) {
    return control.value === "-1" ? { error: "El campo es requerido" } : null;
  }

  public obtenerMensajeValidacion(controlName: string): string {
    let error = "";
    const control = this.filtroForm.get(controlName);
    if (
      (control.touched && control.errors != null) ||
      (control.touched && control.value === "-1")
    ) {
      error = "El campo es requerido";
    }
    return error;
  }

  ngOnDestroy(): void {
    this.levantamientoAvanceService.datosObraSeleccionada$.next(null);
  }
}
